import { useAppDispatch } from '@/app/redux/hooks';
import { setContactFormModalOpen } from '@/app/redux/slices/modalsSlice';

function UnknownErrorMessage() {
  const dispatch = useAppDispatch();
  return (
    <span>
      Something went wrong. Please try again. If the issue persists, please{' '}
      <span
        className="cursor-pointer underline"
        onClick={() => {
          dispatch(setContactFormModalOpen(true));
        }}
      >
        contact support
      </span>
      .
    </span>
  );
}

export const UNKNOWN_ERROR_MESSAGE = <UnknownErrorMessage />;
